(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Images = Lfl.Images || {};

    (function (Images, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Images, 'ImagesDefaultFallbackHandler')) {
            return;
        }

        /**
         * Handles the application of default images used where an image failed to load.
         *
         * @memberOf Lfl.Images
         */
        Lfl.Images.ImagesDefaultFallbackHandler = Images.ImagesDefaultFallbackHandler || {};

        (function (ImagesDefaultFallbackHandler, $, undefined) {
            /**
             * Activates the mechanism for all marked images.
             *
             * @memberOf Lfl.Images.ImagesDefaultFallbackHandler
             */
            ImagesDefaultFallbackHandler.activate = function () {
                $("img[data-default-enable='true']").on('error', handle);
            };

            function handle() {
                const $this = $(this);
                console.error("Missing image " + $this.prop('currentSrc'));

                // Prevent endless cycle if default was missing - could be solved in another way..
                $this.attr('onerror', null);

                $this.attr('data-old-src', this.src);
                $this.attr('src', $this.attr('data-default-image'));

                $this.attr('data-old-srcset', this.srcset);
                $this.attr('srcset', null);
            }
        }(Images.ImagesDefaultFallbackHandler, jQuery));
    }(Lfl.Images, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
